// components/Shop/ProductOptions.js
import React from 'react'
import { useLanguage } from '../../contexts/LanguageContext'
import { useTranslation } from 'react-i18next'
import { getTranslatedLabel, getTranslatedDescription } from '../../utils/getTranslations'
import { formatPrice } from '../../utils/priceUtils'

const ProductOptions = ({ variants }) => {
  const { activeLanguage } = useLanguage()
  const { t } = useTranslation()

  if (!variants || variants.length === 0) return null

  return (
    <div className="mt-4">
      <h2>{t('AVAILABLE_OPTIONS')}</h2>
      <ul>
        {variants.map((variant) => (
          <li key={variant.id} className="block-wrapper" style={{ listStyleType: 'none', paddingLeft: '20px' }}>
            <h5>{getTranslatedLabel(variant, activeLanguage)}</h5>
            <p>{getTranslatedDescription(variant, activeLanguage)}</p>
            <p>
              <strong>{t('PRICE')}:</strong>{' '}
              {formatPrice(variant.price, activeLanguage)}
            </p>
          </li>
        ))}
      </ul>
    </div>
  )
}

export default ProductOptions
